import React from 'react';
import { Switch, Route } from 'react-router-dom';
import SalesPharmacySearch from './salesPharmacySearch';
import PotentialCustomerList from './potentialCustomerList';
import PotentialCustomerDetail from './potentialCustomerDetail';
import ReportsRouter from './reports/reportsRouter';

const InsideSalesRouter = () => (
  <Switch>
    <Route exact path="/sales" component={PotentialCustomerList} />
    <Route exact path="/sales/search" component={SalesPharmacySearch} />
    <Route
      exact
      path="/sales/potentialcustomer/:id"
      component={PotentialCustomerDetail}
    />
    <Route path="/sales/report" component={ReportsRouter} />
  </Switch>
);

export default InsideSalesRouter;
